import React, { ReactNode, useContext } from "react";
import { Party } from './widgets/Party';
import { InteractiveMap } from './InteractiveMap/InteractiveMap';
import { ScheduleColumn, ScheduleColumnDisplayProps, ScheduleColumnProps } from './Schedule/Schedule';

import { CreateStateManager, StateManager } from './widgets/PartyState';
import { DataDisplayPanel } from './InteractiveMap/DataDisplayPanel';
import { StateManagerContext } from './widgets/StateManagerContext';
import { SignUpForm } from "./widgets/SignUpForm";
import { CreateEmptyUIConfig, UIConfig, UIConfigContext } from "./widgets/UIConfigContext";
import { CredentialResponse, GoogleLogin, googleLogout, GoogleOAuthProvider } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { CognitoIdentity } from "./Shared/UserData";




interface GoogleDetails {
    email: string,
    name: string
}

const googleClientId = '835121614665-kuh77kbndgiuho87r66biiq022malkkt.apps.googleusercontent.com';



export type HomePageProps = {
    partyId?: string,
    offset?: string,
    userId?: string,
}

export const HomePage = ({ partyId, offset, userId }: HomePageProps): JSX.Element => {
    const offsetValue = offset === undefined ? undefined : parseInt(offset);
    const stateManagerInit = React.useRef<boolean>(false);
    const stateInitCalled = React.useRef<boolean>(false);

    const stateManager = React.useRef<StateManager | null>(null);

    if (!stateManagerInit.current) {
        stateManagerInit.current = true;
        const sm = CreateStateManager(undefined, partyId, offsetValue, userId);
        console.log('Create State Manager in Homepage =' + sm.getObjId());
        stateManager.current = sm;

    }

    const stateLoadedRef = React.useRef<boolean>(false);
    const [stateLoaded, setStateLoaded] = React.useState<boolean>(false);

    const stateManagerLoadedHandler = () => {
        stateLoadedRef.current = true;
        setStateLoaded(true);
        console.log('setLoaded true for stateManager id=' + (stateManager.current !== null ? stateManager.current?.getObjId() : 'null'));
    }
    const [selectedRegion, setSelectedRegion] = React.useState<string>('US');
    const [showSignUpForm, setShowSignUpForm] = React.useState<boolean>(false);

    const [viewportWidth, viewportHeight] = [window.innerWidth, window.innerHeight];
    let [partyWidth, partyHeight] = [viewportWidth, viewportHeight - 20];
    let displayParty = true;
    let displayInfo = false;
    if (viewportWidth > viewportHeight) {
        displayInfo = true;
        if (viewportHeight < 800) {
            displayParty = false;
        }
        else
            partyWidth = 500; //partyHeight / 1920 * 1080;
    }
    const uiConfig = React.useRef<UIConfig>((() => {
        const uc = CreateEmptyUIConfig();
        uc.width = partyWidth;
        uc.height = partyHeight;
        return uc;
    })());

    const showSignUpHandler = () => {
        setShowSignUpForm(true);
        const panel = document.getElementById("signUpForm");
        if (panel !== null) {
            panel.style.top = '0px';
        }
        else {
            setTimeout(() => {
                const panel = document.getElementById("signUpForm");
                if (panel !== null) {
                    panel.style.top = '0px';
                }
            }, 500);

        }
    }

    const closeSignUpHandler = () => {
        const panel = document.getElementById("signUpForm");
        if (panel !== null) {
            panel.style.top = partyHeight + 'px';
        }
        window.setTimeout(() => { setShowSignUpForm(false) }, 1000);
    }

    if ((!stateLoadedRef.current) && (stateManager.current !== null) && (!stateInitCalled.current)) {
        stateInitCalled.current = true;
        stateManager.current.init(stateManagerLoadedHandler, showSignUpHandler);
    }




    const displaySchedule: ScheduleColumnDisplayProps = {
        width: 170,
        imageHeight: 97,
        panelHeight: 75,
        gap: 14,
        slots: 5,
        style: {
            paddingLeft: "16px",
            paddingRight: "16px",
            paddingTop: "20px"
        }
    }



    const schedule: ScheduleColumnProps = {
        display: displaySchedule

    }



    const moreDataRequest = (region: string) => {
        setSelectedRegion(region);
    }




    console.log('rendering for stateManager id=' + (stateManager.current !== null ? stateManager.current.getObjId() : 'null') + ' stateLoaded = ' + stateLoaded);
    if (stateLoaded && stateManager.current !== null)
        return <StateManagerContext.Provider value={stateManager.current} >

            <UIConfigContext.Provider value={uiConfig.current}>

                <div className="App">
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: "1410px",
                        maxWidth: "1410px",
                        minWidth: "1410px",

                        background: "linear-gradient( rgba(60, 10, 60, 0.85), rgba(60, 60, 0, 0.85) ), url('/images/fanbox-background.png')",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "100%",
                        margin: "auto",

                    }}>
                        <div style={{ overflow: 'clip', maxHeight: (partyHeight + 20) + 'px' }}>
                            <ScheduleColumn {...schedule} /></div>
                        {(displayParty) && <div style={{ width: partyWidth + 'px', height: partyHeight + 'px', marginTop: "20px", borderRadius: "25px", overflow: 'clip', position: 'relative' }}><Party />

                            <div id='signUpForm' style={{ opacity: 1.0, transition: 'top 1s', transitionTimingFunction: 'ease-in-out', position: 'absolute', top: partyHeight + 'px' }}>
                                {showSignUpForm && <SignUpForm width={partyWidth} height={partyHeight} background='#303030' fontSize={16} complete={closeSignUpHandler} />}
                            </div>
                        </div>}
                        {displayInfo &&
                            <div className="scrollablePanel" style={{ width: "691px", height: (partyHeight + 20) + "px", overflow: "auto", paddingLeft: "16px", scrollBehavior: 'smooth', display: 'flex', flexDirection: 'column' }}>
                                <div style={{
                                    width: "675px",
                                    minWidth: "675px",
                                    maxWidth: "675px",
                                    height: "69px",
                                    minHeight: "69px",
                                    maxHeight: "69px",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "left",
                                    alignItems: "center",
                                    backgroundColor: "#131313",
                                    borderRadius: "25px",
                                    marginTop: "20px",
                                    marginBottom: "12px",

                                }}>
                                    <img src={"/images/fbLogo-small.png"} style={{
                                        width: "40.33px",
                                        minWidth: "40.33px",
                                        maxWidth: "40.33px",
                                        paddingLeft: "18px"
                                    }} />
                                    <img src={"/images/FANBOX.png"} style={{
                                        width: "88px",
                                        minWidth: "88px",
                                        maxWidth: "88px",
                                        paddingLeft: "10.67px"
                                    }} /><a href="#WhatIsFanbox" style={{ textDecoration: 'none' }}>
                                        <div style={{
                                            width: "145px",
                                            minWidth: "145px",
                                            maxWidth: "145px",
                                            height: "27px",
                                            minHeight: "27px",
                                            maxHeight: "27px",
                                            backgroundColor: "#232323",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            marginLeft: "21px",
                                            borderRadius: "10px"
                                        }}>
                                            <span style={{
                                                fontSize: "14px",
                                                height: "27px",
                                                lineHeight: "27px",
                                                fontWeight: 700,
                                                textAlign: "center",
                                                color: "white"
                                            }}>What is Fanbox?</span>
                                            <div style={{
                                                width: "8px",
                                                minWidth: "8px",
                                                maxWidth: "8px",
                                                height: "8px",
                                                minHeight: "8px",
                                                maxHeight: "8px",
                                                marginTop: "8px",
                                                marginLeft: "4px",

                                                backgroundColor: "#1877F2",
                                                borderRadius: "4px"
                                            }}></div>
                                        </div></a>
                                    <a href="#ForFans" style={{ textDecoration: 'none' }}>
                                        <div style={{
                                            width: "89px",
                                            minWidth: "89px",
                                            maxWidth: "89px",
                                            height: "27px",
                                            minHeight: "27px",
                                            maxHeight: "27px",
                                            backgroundColor: "#232323",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            marginLeft: "16px",
                                            borderRadius: "10px"
                                        }}>
                                            <span style={{
                                                fontSize: "14px",
                                                height: "27px",
                                                lineHeight: "27px",
                                                fontWeight: 700,
                                                textAlign: "center",
                                                color: 'white'
                                            }}>For Fans</span>
                                            <div style={{
                                                width: "8px",
                                                minWidth: "8px",
                                                maxWidth: "8px",
                                                height: "8px",
                                                minHeight: "8px",
                                                maxHeight: "8px",
                                                marginTop: "8px",
                                                marginLeft: "4px",

                                                backgroundColor: "#FF0789",
                                                borderRadius: "4px",


                                            }}></div>
                                        </div>
                                    </a>
                                    <a href="#ForCreators" style={{ textDecoration: 'none' }}>
                                        <div style={{
                                            width: "117px",
                                            minWidth: "117px",
                                            maxWidth: "117px",
                                            height: "27px",
                                            minHeight: "27px",
                                            maxHeight: "27px",
                                            backgroundColor: "#232323",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            marginLeft: "16px",
                                            borderRadius: "10px"
                                        }}>
                                            <span style={{
                                                fontSize: "14px",
                                                height: "27px",
                                                lineHeight: "27px",
                                                fontWeight: 700,
                                                textAlign: "center",
                                                color: 'white',

                                            }}>For Creators</span>
                                            <div style={{
                                                width: "8px",
                                                minWidth: "8px",
                                                maxWidth: "8px",
                                                height: "8px",
                                                minHeight: "8px",
                                                maxHeight: "8px",
                                                marginTop: "8px",
                                                marginLeft: "4px",

                                                backgroundColor: "#92CA36",
                                                borderRadius: "4px"
                                            }}></div>
                                        </div>
                                    </a>
                                    <a href="#ForBrands" style={{ textDecoration: 'none' }}>
                                        <div style={{
                                            width: "105px",
                                            minWidth: "105px",
                                            maxWidth: "105px",
                                            height: "27px",
                                            minHeight: "27px",
                                            maxHeight: "27px",
                                            backgroundColor: "#232323",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            marginLeft: "16px",
                                            borderRadius: "10px"
                                        }}>
                                            <span style={{
                                                fontSize: "14px",
                                                height: "27px",
                                                lineHeight: "27px",
                                                fontWeight: 700,
                                                textAlign: "center",
                                                color: 'white'
                                            }}>For Brands</span>
                                            <div style={{
                                                width: "8px",
                                                minWidth: "8px",
                                                maxWidth: "8px",
                                                height: "8px",
                                                minHeight: "8px",
                                                maxHeight: "8px",
                                                marginTop: "8px",
                                                marginLeft: "4px",

                                                backgroundColor: "#FFB602",
                                                borderRadius: "4px"
                                            }}></div>
                                        </div>
                                    </a>
                                </div>

                                <InteractiveMap moreDataRequest={moreDataRequest} idPrefix='StateMap' />
                                <div style={{
                                    width: "675px",
                                    minWidth: "675px",
                                    maxWidth: "675px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "left",
                                    alignItems: "left",
                                    backgroundColor: "#131313",
                                    borderRadius: "25px",
                                    marginTop: "12px",
                                    marginBottom: "12px",
                                    paddingLeft: "55px",

                                    position: "relative"
                                }}
                                    id="WhatIsFanbox">
                                    <div style={{

                                        width: "480px",
                                        minWidth: "480px",
                                        maxWidth: "480px",
                                        maxHeight: "47px",
                                        lineHeight: "51px",
                                        marginTop: "34px"

                                    }}>
                                        <p style={{ fontSize: "45px", fontWeight: 900, color: "white", textAlign: "left", position: "relative", top: "-51px" }}>What is Fanbox<span style={{ color: "#1877F2" }}>?</span></p>
                                    </div>
                                    <div style={{
                                        width: "390px",
                                        minWidth: "390px",
                                        maxWidth: "390px",
                                        maxHeight: "76px",
                                        lineHeight: "38px",
                                        marginTop: "27px",
                                        marginBottom: "15px"


                                    }}>
                                        <p style={{ fontSize: "35px", fontWeight: 900, color: "white", textAlign: "left", position: "relative", top: "-51px" }}>It's where passions <span style={{ color: "#FF0789" }}>unite</span> & <span style={{ color: "#FFB602" }}>fandoms</span> collide<span style={{ color: "#9747FF" }}>!</span></p>
                                    </div>
                                    <div style={{
                                        width: "480px",
                                        minWidth: "480px",
                                        maxWidth: "480px",
                                        marginTop: "28px",
                                        marginBottom: "5px"


                                    }}>
                                        <p style={{ fontSize: "18px", fontWeight: 400, color: "white", textAlign: "left", position: "relative", top: "-51px" }}>
                                            We bring fans and creators together in ways that unleash both’s creativity. We transform traditional live-streams and chat rooms by packing them with games, challenges, and features that empower you to express, share, collaborate, and compete with your community. Our platform helps uncover your fandom DNA, connecting you with the movies, music, shows, and games you're truly passionate about.
                                        </p>
                                        <p style={{ fontSize: "18px", fontWeight: 400, color: "white", textAlign: "left", position: "relative", top: "-51px" }}>
                                            No one can tell you what Fanbox is, just take the red pill to find out how deep your Fandom goes.
                                        </p>
                                    </div>
                                    <div style={{
                                        width: "186px",
                                        minWidth: "186px",
                                        maxWidth: "186px",
                                        height: "53px",
                                        minHeight: "53px",
                                        maxHeight: "53px",
                                        borderRadius: "75px",
                                        backgroundColor: "#1877F2",
                                        lineHeight: "53px",
                                        fontSize: "18px",
                                        fontWeight: 700,
                                        textAlign: "center",
                                        color: "white",
                                        position: "relative",
                                        top: "-40px"
                                    }}>Enter Chat</div>
                                    <img src={"/images/fbLogo-small.png"} style={{ position: "absolute", left: "567px", top: "30px", width: "53px", maxWidth: "53px", minWidth: "53px" }} />
                                </div>
                                <DataDisplayPanel width={675} height={530} idPrefix='DataDisplayPanel' region={selectedRegion} />

                                <div style={{
                                    width: "675px",
                                    minWidth: "675px",
                                    maxWidth: "675px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "left",
                                    alignItems: "left",
                                    backgroundColor: "#131313",
                                    borderRadius: "25px",
                                    marginTop: "12px",
                                    marginBottom: "12px",
                                    paddingLeft: "55px",

                                    position: "relative"
                                }}
                                    id="ForFans">
                                    <div style={{

                                        width: "480px",
                                        minWidth: "480px",
                                        maxWidth: "480px",
                                        maxHeight: "47px",
                                        lineHeight: "51px",
                                        marginTop: "34px"

                                    }}>
                                        <p style={{ fontSize: "45px", fontWeight: 900, color: "white", textAlign: "left", position: "relative", top: "-51px" }}>For <span style={{ color: "#FF0789" }}>Fans</span>.</p>
                                    </div>

                                    <div style={{
                                        width: "480px",
                                        minWidth: "480px",
                                        maxWidth: "480px",
                                        marginTop: "28px"

                                    }}>
                                        <ul style={{ textAlign: "left", color: "#FF0789", fontSize: "36px", lineHeight: "18px", position: "relative", top: "-36px" }}>
                                            <li style={{ paddingBottom: "10px" }}><span style={{ fontSize: "18px", fontWeight: 400, color: "white", position: "relative", top: "-5px" }}>We unlock new ways to connect with your favorite creators through interactive experiences</span></li>
                                            <li style={{ paddingBottom: "10px" }}><span style={{ fontSize: "18px", fontWeight: 400, color: "white", position: "relative", top: "-5px" }}>We give you the tools to create and express your unique vision and experience of fandom</span></li>
                                            <li style={{ paddingBottom: "10px" }}><span style={{ fontSize: "18px", fontWeight: 400, color: "white", position: "relative", top: "-5px" }}>We leave it up to you to decide with whom to share your information and opinions with</span></li>
                                            <li style={{ paddingBottom: "10px" }}><span style={{ fontSize: "18px", fontWeight: 400, color: "white", position: "relative", top: "-5px" }}>We don't use your personal information for commercial gain, for instance selling it to third parties to use for ad targeting. For more information, please see our privacy policy. </span></li>

                                        </ul>

                                    </div>
                                    <div style={{
                                        width: "186px",
                                        minWidth: "186px",
                                        maxWidth: "186px",
                                        height: "53px",
                                        minHeight: "53px",
                                        maxHeight: "53px",
                                        borderRadius: "75px",
                                        backgroundColor: "#FF0789",
                                        lineHeight: "53px",
                                        fontSize: "18px",
                                        fontWeight: 700,
                                        textAlign: "center",
                                        color: "white",
                                        position: "relative",
                                        top: "-40px"
                                    }}>Enter Chat</div>
                                    <img src={"/images/fbLogo-small.png"} style={{ position: "absolute", left: "567px", top: "30px", width: "53px", maxWidth: "53px", minWidth: "53px" }} />
                                </div>

                                <div style={{
                                    width: "675px",
                                    minWidth: "675px",
                                    maxWidth: "675px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "left",
                                    alignItems: "left",
                                    backgroundColor: "#131313",
                                    borderRadius: "25px",
                                    marginTop: "12px",
                                    marginBottom: "12px",
                                    paddingLeft: "55px",

                                    position: "relative"
                                }}
                                    id="ForCreators">
                                    <div style={{

                                        width: "480px",
                                        minWidth: "480px",
                                        maxWidth: "480px",
                                        maxHeight: "47px",
                                        lineHeight: "51px",
                                        marginTop: "34px"

                                    }}>
                                        <p style={{ fontSize: "45px", fontWeight: 900, color: "white", textAlign: "left", position: "relative", top: "-51px" }}>For <span style={{ color: "#92CA36" }}>Creators</span>.</p>
                                    </div>

                                    <div style={{
                                        width: "480px",
                                        minWidth: "480px",
                                        maxWidth: "480px",
                                        marginTop: "28px"

                                    }}>
                                        <ul style={{ textAlign: "left", color: "#92CA36", fontSize: "36px", lineHeight: "18px", position: "relative", top: "-36px" }}>
                                            <li style={{ paddingBottom: "10px" }}><span style={{ fontSize: "18px", fontWeight: 400, color: "white", position: "relative", top: "-5px" }}>We provide deep insights into your audience's passions and preferences.</span></li>
                                            <li style={{ paddingBottom: "10px" }}><span style={{ fontSize: "18px", fontWeight: 400, color: "white", position: "relative", top: "-5px" }}>We help you understand which audiences connect most deeply with your content and why.</span></li>
                                            <li style={{ paddingBottom: "10px" }}><span style={{ fontSize: "18px", fontWeight: 400, color: "white", position: "relative", top: "-5px" }}>We enable you to create custom experiences for your fans, including sponsored content where they can share their information and opinions directly with you or your sponsors.</span></li>

                                        </ul>

                                    </div>
                                    <div style={{
                                        width: "186px",
                                        minWidth: "186px",
                                        maxWidth: "186px",
                                        height: "53px",
                                        minHeight: "53px",
                                        maxHeight: "53px",
                                        borderRadius: "75px",
                                        backgroundColor: "#92CA36",
                                        lineHeight: "53px",
                                        fontSize: "18px",
                                        fontWeight: 700,
                                        textAlign: "center",
                                        color: "white",
                                        position: "relative",
                                        top: "-40px"
                                    }}>Get In Contact</div>
                                    <img src={"/images/fbLogo-small.png"} style={{ position: "absolute", left: "567px", top: "30px", width: "53px", maxWidth: "53px", minWidth: "53px" }} />
                                </div>

                                <div style={{
                                    width: "675px",
                                    minWidth: "675px",
                                    maxWidth: "675px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "left",
                                    alignItems: "left",
                                    backgroundColor: "#131313",
                                    borderRadius: "25px",
                                    marginTop: "12px",
                                    marginBottom: "20px",
                                    paddingLeft: "55px",

                                    position: "relative"
                                }}
                                    id="ForBrands">
                                    <div style={{

                                        width: "480px",
                                        minWidth: "480px",
                                        maxWidth: "480px",
                                        maxHeight: "47px",
                                        lineHeight: "51px",
                                        marginTop: "34px"

                                    }}>
                                        <p style={{ fontSize: "45px", fontWeight: 900, color: "white", textAlign: "left", position: "relative", top: "-51px" }}>For <span style={{ color: "#FFB602" }}>Brands</span>.</p>
                                    </div>

                                    <div style={{
                                        width: "480px",
                                        minWidth: "480px",
                                        maxWidth: "480px",
                                        marginTop: "28px"

                                    }}>
                                        <ul style={{ textAlign: "left", color: "#FFB602", fontSize: "36px", lineHeight: "18px", position: "relative", top: "-36px" }}>
                                            <li style={{ paddingBottom: "10px" }}><span style={{ fontSize: "18px", fontWeight: 400, color: "white", position: "relative", top: "-5px" }}>Get honest opinions from your actual customers expressing themselves authentically, not from a paid panel of semi-professional box tickers. </span></li>
                                            <li style={{ paddingBottom: "10px" }}><span style={{ fontSize: "18px", fontWeight: 400, color: "white", position: "relative", top: "-5px" }}>Get insights derived from the genuine responses of customers to your messaging when experienced during a genuine and representative content consumption journey.</span></li>
                                            <li style={{ paddingBottom: "10px" }}><span style={{ fontSize: "18px", fontWeight: 400, color: "white", position: "relative", top: "-5px" }}>Understand the preferences, motivations and behaviors of your customer segments through the lens of over 12,000 metrics.</span></li>
                                            <li style={{ paddingBottom: "10px" }}><span style={{ fontSize: "18px", fontWeight: 400, color: "white", position: "relative", top: "-5px" }}>Build your own fan following, engage in a 2-way conversation and build your own 1P customer data.</span></li>
                                        </ul>

                                    </div>
                                    <div style={{
                                        width: "186px",
                                        minWidth: "186px",
                                        maxWidth: "186px",
                                        height: "53px",
                                        minHeight: "53px",
                                        maxHeight: "53px",
                                        borderRadius: "75px",
                                        backgroundColor: "#FFB602",
                                        lineHeight: "53px",
                                        fontSize: "18px",
                                        fontWeight: 700,
                                        textAlign: "center",
                                        color: "white",
                                        position: "relative",
                                        top: "-40px"
                                    }}>Find out more</div>
                                    <img src={"/images/fbLogo-small.png"} style={{ position: "absolute", left: "567px", top: "30px", width: "53px", maxWidth: "53px", minWidth: "53px" }} />
                                </div>
                                {/*<GoogleLogin onSuccess={(credentialResponse : CredentialResponse) => {
                            console.log('Google log in Succeeded');
                            //console.log(credentialResponse);


                            const s = jwtDecode(credentialResponse.credential ?? '') as any;
                            const cognito : CognitoIdentity = {
                                provider : 'Google',
                                id : '',
                                accessToken : credentialResponse.credential ?? '',
                                email : s.email,
                                nickname : s.name
                            }
                            console.log('email : ' + s.email);
                            console.log('name :' + s.name);
                            console.log(JSON.stringify(cognito));

                            //const stateManager = useContext(StateManagerContext);
                            if(stateManager.current !== null)
                            stateManager.current.updateCognito(cognito);

                        
                            
                        }}

                        onError={()=> {console.log('Google Log in Failed')}}

                        useOneTap
                        auto_select/>*/}

                                <button onClick={() => { console.log('Logging out of Google'); googleLogout(); }}>Log out of Google</button>

                            </div>

                        }
                    </div>
                </div>
            </UIConfigContext.Provider>

        </StateManagerContext.Provider>;
    else return <div style={{
        minWidth : viewportWidth + 'px',
        width : viewportWidth + 'px',
        maxWidth : viewportWidth + 'px',
        minHeight : viewportHeight + 'px',
        height : viewportHeight + 'px',
        maxHeight : viewportHeight + 'px',
        backgroundColor : 'black',
        backgroundImage : 'url("/images/spinner.gif")',
        backgroundPosition : 'center',
        backgroundRepeat : 'no-repeat',
        backgroundSize : 'auto'
    }}> The App is loading</div>;


}